// Returns the default age-segment name (e.g. "Age 18+", "Age 21+") to use
// for the given set of market codes. Business rules preserved from the
// legacy `Filters/utils/utils.ts` copy — HSS → 35+, CTM-CA/CTM-GL → 21+,
// CTM-AA → 18-64, everything else → 18+. Follow-up F11 moves these bounds
// server-side.
export const getAgeSegmentsNameBasedOnMarket = (selectedMarkets: string[]) => {
  if (selectedMarkets.every((obj) => obj === "HSS" || obj?.includes("HSS"))) {
    return "Age 35+";
  } else if (
    selectedMarkets.every(
      (obj) => obj === "Spirit Drinkers" || obj?.includes("CTM-CA")
    ) ||
    selectedMarkets.every(
      (obj: any) =>
        obj === "Gallo" || obj?.includes("CTM-GL"),
    )
  ) {
    return "Age 21+";
  } else if (
    selectedMarkets.every(
      (obj) => obj === "A&A Management" || obj?.includes("CTM-AA")
    )
  ) {
    return "Age 18-64";
  } else {
    return "Age 18+";
  }
};
